<template>
  <Layout>
    <div>
      <v-row justify="start">
        <v-col class="d-flex justify-start">
          <v-btn elevation="2" @click="goBack"> ย้อนกลับ </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <!-- <v-col cols="4">
          <v-text-field v-model="sku" label="SKU"></v-text-field>
        </v-col> -->
        <v-col cols="9">
          <v-text-field
            v-model="name"
            label="ชื่อร้าน"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <!-- <v-btn elevation="2" @click="fetchData" color="primary">
            ค้นหา
          </v-btn> -->
          <v-btn elevation="2" @click="clear"> ยกเลิก </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-if="!isLoading">
      <template v-if="hasData">
        <TableStockDetail :data="filter" />
        <!-- <v-row class="py-4">
          <v-col>
            <MapMaker :data="mapMakerData" />
          </v-col>
        </v-row> -->
      </template>
      <template v-else>
        <v-row justify="center">
          <v-col>- ไม่พบข้อมูล -</v-col>
        </v-row>
        <!-- <v-row justify="center">
          <v-col>
            <v-btn @click="goBack()">
              กลับไปยังหน้า Stock Live
            </v-btn>
          </v-col>
        </v-row> -->
      </template>
    </div>
    <v-row v-if="mapMakerData" class="py-4">
      <v-col v-if="showMapMaker">
        <MapMaker :data="mapMakerData" />
      </v-col>
    </v-row>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/components/Layout'
import TableStockDetail from '@/components/TableStockDetail'
import MapMaker from '@/components/MapMaker'

export default {
  computed: {
    ...mapState({
      me: (state) => state.me.data,
      stockDetail: (state) => state.stock.stockDetail,
      isLoading: (state) => state.stock.isLoading,
    }),

    filter() {
      return this.stockDetail?.filter((i) =>
        i?.branch_name
          ?.toUpperCase()
          .includes(this.name?.toUpperCase()),
      )
    },

    hasData() {
      return (
        this.stockDetail?.length > 0 && this.stockDetail !== 'success'
      )
    },
  },

  watch: {
    stockDetail() {
      if (!this.mapMakerData) {
        this.mapMakerData = this.stockDetail
      }
    },
  },

  components: {
    Layout,
    TableStockDetail,
    MapMaker,
  },

  data() {
    return {
      showMapMaker: true,
      timer: null,
      sku: '',
      name: '',
      mapMakerData: null,
    }
  },

  created() {},

  mounted() {
    this.$nextTick(() => {
      this.sku = this.$route.query?.sku ?? ''
      this.fetchData()
      this.timer = setInterval(this.fetchData, 10 * 60 * 1000)
    })
  },

  methods: {
    async fetchData() {
      await this.$store.dispatch('stock/getStockDetail', {
        sku: this.sku,
        name: this.name,
      })
    },

    clear() {
      this.name = ''
      this.fetchData()
    },

    cancelAutoUpdate() {
      clearInterval(this.timer)
    },

    goBack() {
      this.cancelAutoUpdate()
      this.$router.push({ name: 'StockCard' })
    },
  },

  beforeUnmount() {
    this.cancelAutoUpdate()
  },
}
</script>
